import React from 'react';
import { Link } from 'react-router-dom';
import { Github, Linkedin, Twitter, MapPin } from 'lucide-react';

export default function Footer() {
  const cols = [
    { title: 'Platform', links: [['Viso Yard', '/platform/viso-yard'], ['Viso Warehouse', '/platform/viso-warehouse'], ['Viso Factory', '/platform/viso-factory'], ['Viso Data', '/platform/viso-data']] },
    { title: 'Industries', links: [['Ports & Terminals', '/industries/ports-terminals'], ['Warehousing & Distribution', '/industries/warehousing-distribution'], ['Manufacturing', '/industries/manufacturing'], ['Logistics & Supply Chain', '/industries/logistics-supply-chain']] },
    { title: 'Company', links: [['About', '/company/about'], ['Careers', '/company/careers'], ['Services', '/services'], ['Partners', '/partners'], ['Contact', '/contact']] },
    { title: 'Resources', links: [['Blog', '/resources/blog'], ['FAQs', '/resources/faqs'], ['Login', '/login']] },
  ];

  const offices = [
    { region: 'India', cities: 'Mumbai · Lucknow · Ahmedabad · Bhubaneshwar' },
    { region: 'USA', cities: 'Washington' },
  ];

  return (
    <footer className="border-t border-white/5 bg-[#05070a]">
      <div className="max-w-7xl mx-auto px-6 py-14 grid md:grid-cols-6 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 font-display font-bold text-lg">
            <img
              src="/logo.png"
              alt="Visotonics"
              className="h-8 w-auto"
            />
          </div>
          <p className="text-sm text-slate-400 mt-3 max-w-sm">
            Industrial Physical AI — unified video analytics for seaports, warehouses, airports and enterprises.
          </p>

          {/* Offices */}
          <div className="mt-5 space-y-2">
            {offices.map((o) => (
              <div key={o.region} className="flex items-start gap-2 text-xs text-slate-400">
                <MapPin className="w-3.5 h-3.5 text-cyan-300 mt-0.5 flex-shrink-0" />
                <div>
                  <span className="text-cyan-300 font-semibold">{o.region}:</span>{' '}
                  <span className="text-slate-300">{o.cities}</span>
                </div>
              </div>
            ))}
          </div>

          <div className="flex items-center gap-3 mt-5 text-slate-400">
            <a
              href="https://www.linkedin.com/company/visotonics/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visotonics on LinkedIn"
              className="hover:text-cyan-300"
            >
              <Linkedin className="w-4 h-4" />
            </a>
            <a href="#" aria-label="twitter" className="hover:text-cyan-300"><Twitter className="w-4 h-4" /></a>
            <a href="#" aria-label="github" className="hover:text-cyan-300"><Github className="w-4 h-4" /></a>
          </div>
        </div>
        {cols.map((c) => (
          <div key={c.title}>
            <div className="text-xs uppercase tracking-widest text-slate-500 mb-3">{c.title}</div>
            <ul className="space-y-2">
              {c.links.map(([label, to]) => (
                <li key={label}><Link to={to} className="text-sm text-slate-300 hover:text-cyan-300">{label}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Visotonics. All rights reserved.</div>
          <div className="flex gap-5">
            <Link to="/legal/privacy" className="hover:text-cyan-300">Privacy</Link>
            <Link to="/legal/terms" className="hover:text-cyan-300">Terms</Link>
            <Link to="/legal/security" className="hover:text-cyan-300">Security</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
